<div class="filters-bar" [class.client-filters]="role === 'client'">
	<mat-card class="mt-0" id="tag-dropzone-filter" cdkDropList (cdkDropListDropped)="tagsDropAssign.drop($event)">
		<mat-card-content class="p-0">
			<div class="d-flex flex-wrap align-items-center justify-contents-between mx-1">
				<form
					#filtersFormDirective="ngForm"
					[formGroup]="filtersFormGroup"
					class="mt-2 flex-fill d-flex flex-wrap"
					[class]="role === 'client' ? 'w-75' : 'w-100'"
					(submit)="filterListItems()">
					<mat-form-field [ngClass]="role === 'client' ? 'w-100 ms-1' : 'reduced-width-field-lg'">
						<mat-label
							>{{ 'CONTRACT_NOTICES.PUBLISHED_DATE' | translate }}
							<!-- workaround for material-chrome bug -->
							<select id="publishedDate" style="display: none"></select>
						</mat-label>
						<mat-date-range-input [rangePicker]="picker" color="primary">
							<input id="publishedDateFrom" formControlName="createdAtFrom" matStartDate placeholder="{{ 'CLIPS.DATE_FROM' | translate }}" />
							<input id="publishedDateTo" formControlName="createdAtTo" matEndDate placeholder="{{ 'CLIPS.DATE_TO' | translate }}" />
						</mat-date-range-input>
						<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-date-range-picker #picker>
							<mat-date-range-picker-actions>
								<button mat-button matDateRangePickerCancel>{{ 'BUTTON.CANCEL' | translate }}</button>
								<button mat-raised-button color="primary" matDateRangePickerApply (click)="instantSearch ? filterListItems() : null">{{ 'BUTTON.APPLY' | translate }}</button>
							</mat-date-range-picker-actions>
						</mat-date-range-picker>
					</mat-form-field>

					<!-- @if (dataAdministrationType === 'CONTRACT_NOTICES' && role === 'client') {
					<mat-form-field class="ms-1" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label
							>{{ 'CONTRACT_NOTICES.DELIVERY_DATE' | translate }}
							 workaround for material-chrome bug
							<select id="deliveryDate" style="display: none"></select>
						</mat-label>
						<mat-date-range-input [rangePicker]="deliveryDatePicker" color="primary" [max]="DATE_RANGE_LIMITS.dateTo">
							<input id="deliveryDateFrom" formControlName="deliveryDateFrom" matStartDate placeholder="{{ 'CLIPS.DATE_FROM' | translate }}" />
							<input id="deliveryDateTo" formControlName="deliveryDateTo" matEndDate placeholder="{{ 'CLIPS.DATE_TO' | translate }}" />
						</mat-date-range-input>
						<mat-datepicker-toggle matIconSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
						<mat-date-range-picker #deliveryDatePicker>
							<mat-date-range-picker-actions>
								<button
									type="button"
									mat-raised-button
									color="primary"
									class="me-1"
									aria-label="Reset date form button"
									matTooltip="{{ 'CLIPS.RESET_FORM' | translate }}"
									matTooltipPosition="below"
									(click)="
										filtersFormGroup.controls['deliveryDateFrom'].setValue(null);
										filtersFormGroup.controls['deliveryDateTo'].setValue(null);
										instantSearch ? filterListItems() : null
									"
									matDateRangePickerApply>
									<mat-icon class="m-0">restart_alt</mat-icon>
								</button>
								<button mat-button matDateRangePickerCancel>{{ 'BUTTON.CANCEL' | translate }}</button>
								<button mat-raised-button color="primary" matDateRangePickerApply (click)="instantSearch ? filterListItems() : null">{{ 'BUTTON.APPLY' | translate }}</button>
							</mat-date-range-picker-actions>
						</mat-date-range-picker>
					</mat-form-field>
					} -->

					<mat-form-field class="ms-1" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label
							>{{ 'CONTRACT_NOTICES.TYPE' | translate }}
							<!-- workaround for material-chrome bug -->
							<select id="types" style="display: none"></select>
						</mat-label>
						<mat-select id="types" formControlName="types" multiple (valueChange)="instantSearch ? filterListItemsDelayed() : null">
							@if (dataAdministrationType === 'CONTRACT_NOTICES') {
							<mat-optgroup label="{{ 'CONTRACT_NOTICES.TITLE' | translate }}">
								<button
									type="button"
									mat-raised-button
									color="primary"
									class="group-selection-button"
									aria-label="toggle selection"
									matTooltip="{{ 'ASSORTED.SELECT_DESELECT' | translate }}"
									matTooltipPosition="below"
									(click)="selectTypeSubgroupItems('CONTRACT_NOTICE')">
									<mat-icon class="m-0">checklist</mat-icon>
								</button>

								@for (type of contractNoticesTypes; track $index) {
								<mat-option [value]="type">{{ 'CONTRACT_NOTICES.' + type | translate }}</mat-option>
								}
							</mat-optgroup>
							} @else if (dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS') {

							<mat-optgroup label="{{ 'CONTRACT_ANNOUNCEMENTS.TITLE' | translate }}">
								<button
									type="button"
									mat-raised-button
									color="primary"
									class="group-selection-button"
									aria-label="toggle selection"
									matTooltip="{{ 'ASSORTED.SELECT_DESELECT' | translate }}"
									matTooltipPosition="below"
									(click)="selectTypeSubgroupItems('CONTRACT_ANNOUNCEMENT')">
									<mat-icon class="m-0">checklist</mat-icon>
								</button>

								@for (type of contractAnnouncementsTypes; track $index) {
								<mat-option [value]="type">{{ 'CONTRACT_ANNOUNCEMENTS.' + type | translate }}</mat-option>
								}
							</mat-optgroup>
							}
						</mat-select>
					</mat-form-field>

					<mat-form-field class="ms-1" [ngClass]="role === 'client' ? 'w-100' : 'reduced-width-field-sm'">
						<mat-label>{{ 'CONTRACT_NOTICES.COUNTRY' | translate }}</mat-label>
						<!-- workaround for material-chrome bug -->
						<select id="country" style="display: none" autocomplete="country"></select>
						<mat-select id="country" formControlName="countries" multiple (valueChange)="instantSearch ? filterListItemsDelayed() : null">
							@for (country of countries; track $index) {
							<mat-option [value]="country.countryCode" [disabled]="!country.availability">{{ 'COUNTRIES.' + country.countryCode | translate }}</mat-option>
							}
						</mat-select>
					</mat-form-field>

					<mat-form-field class="ms-1 flex-fill" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label>{{ 'CONTRACT_NOTICES.CONTRACT_AUTHORITY' | translate }}</mat-label>
						<input
							type="text"
							matInput
							formControlName="contractAuthority"
							[matAutocomplete]="contractAuthorityAutocomplete"
							matTooltip="{{ utils.getParameterByLanguageScript(filtersFormGroup.controls['contractAuthority'].value, 'name', true) }}"
							matTooltipPosition="below" />
						<mat-autocomplete #contractAuthorityAutocomplete="matAutocomplete" [displayWith]="displayFn.bind(this)">
							@for (filteredItem of filteredContractAuhorities; track $index) {
							<mat-option [value]="filteredItem" (onSelectionChange)="instantSearch ? filterListItemsDelayed() : null">{{
								utils.getParameterByLanguageScript(filteredItem, 'name', true)
							}}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>

					<mat-form-field class="ms-1 flex-fill" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label>{{ 'BUTTON.SEARCH' | translate }}</mat-label>
						<input matInput name="searchText" formControlName="searchText" placeholder="" />
					</mat-form-field>

					@if(role === 'admin') {
					<mat-form-field class="ms-1 flex-fill reduced-width-field-md">
						<mat-label for="clip-medium">{{ 'CLIPS.MEDIUM' | translate }}</mat-label>
						<input type="text" matInput formControlName="medium" [matAutocomplete]="mediumAutocomplete" />
						<mat-autocomplete #mediumAutocomplete="matAutocomplete" [displayWith]="displayMediumFn.bind(this)">
							@for (filteredItem of filteredMediums; track $index) {
							<mat-option [value]="filteredItem">{{ utils.getParameterByLanguageScript(filteredItem, 'name') }}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
					} @if (dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS' && role === 'client') {
					<mat-form-field class="ms-1 flex-fill">
						<mat-label>{{ 'CONTRACT_NOTICES.CONTRACTOR' | translate }}</mat-label>
						<input type="text" matInput formControlName="contractor" [matAutocomplete]="contractorAutocomplete" />
						<mat-autocomplete #contractorAutocomplete="matAutocomplete" [displayWith]="displayFn.bind(this)">
							@for (filteredItem of filteredContractors; track $index) {
							<mat-option [value]="filteredItem" (onSelectionChange)="instantSearch ? filterListItemsDelayed() : null">{{
								utils.getParameterByLanguageScript(filteredItem, 'name', true)
							}}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
					} @if (role === 'client') {
					<div class="slider-container ms-2" [ngClass]="role === 'client' ? 'w-75' : 'flex-fill'">
						<mat-label>{{ 'CONTRACT_NOTICES.ESTIMATED_PURCHASE_VALUE_CURRENCY' | translate }}</mat-label>
						<mat-slider class="w-100" min="0" max="9" step="1" showTickMarks [discrete]="role !== 'client'" [displayWith]="estimatedValueLabel">
							<input matSliderStartThumb value="0" formControlName="estimatedPurchaseValueFrom" (dragEnd)="instantSearch ? filterListItemsDelayed() : null" />
							<input matSliderEndThumb value="9" formControlName="estimatedPurchaseValueTo" (dragEnd)="instantSearch ? filterListItemsDelayed() : null" />
						</mat-slider>
						@if (role === 'client') {
							<div class="slider-value-labels">
								<span>{{ estimatedValueLabel(filtersFormGroup.controls['estimatedPurchaseValueFrom'].value ?? 0) }}</span>
								<span>{{ estimatedValueLabel(filtersFormGroup.controls['estimatedPurchaseValueTo'].value ?? 9) }}</span>
							</div>
						}
					</div>

					@if (dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS') {
					<div class="slider-container" [ngClass]="role === 'client' ? 'ms-2 w-75' : 'ms-4 flex-fill'">
						<mat-label>{{ 'CONTRACT_NOTICES.AGREEMENT_VALUE_CURRENCY' | translate }}</mat-label>
						<mat-slider class="w-100" min="0" max="9" step="1" showTickMarks [discrete]="role !== 'client'" [displayWith]="estimatedValueLabel">
							<input matSliderStartThumb value="0" formControlName="agreementValueFrom" (dragEnd)="instantSearch ? filterListItemsDelayed() : null" />
							<input matSliderEndThumb value="9" formControlName="agreementValueTo" (dragEnd)="instantSearch ? filterListItemsDelayed() : null" />
						</mat-slider>
						@if (role === 'client') {
							<div class="slider-value-labels">
								<span>{{ estimatedValueLabel(filtersFormGroup.controls['agreementValueFrom'].value ?? 0) }}</span>
								<span>{{ estimatedValueLabel(filtersFormGroup.controls['agreementValueTo'].value ?? 9) }}</span>
							</div>
						}
					</div>
					}
					<mat-checkbox class="pb-3" [ngClass]="{ 'w-100': role === 'client' }" formControlName="searchAllCategories" (change)="instantSearch ? filterListItemsDelayed() : null"
						>{{ 'CONTRACT_NOTICES.SEARCH_ALL_CATEGORIES' | translate }}
					</mat-checkbox>
					} @if (role === 'admin') {
					<mat-form-field class="ms-1 reduced-width-field-sm wide-panel">
						<mat-label>{{ 'CLIPS.ADDITIONAL_FILTERS' | translate }}</mat-label>
						<select id="flags" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select id="flags" formControlName="flags" panelClass="wide-panel" multiple>
							<!-- <mat-option value="searchAllCategories">{{ 'CONTRACT_NOTICES.SEARCH_ALL_CATEGORIES' | translate }}</mat-option> -->
							<mat-option value="withoutTag">{{ 'CLIPS.SHOW_WITHOUT_TAG' | translate }}</mat-option>
							<mat-option value="additionalMediums">{{ 'CONTRACT_NOTICES.SHOW_ONLY_ADDITIONAL' | translate }}</mat-option>
							@if (dataAdministrationType === 'CONTRACT_NOTICES') {
							<mat-option value="onlyFake">{{ 'CONTRACT_NOTICES.SHOW_ONLY_FAKE' | translate }}</mat-option>
							}
							<mat-option value="autoTaggedAi">{{ 'CONTRACT_NOTICES.AUTO_TAGGED_AI' | translate }}</mat-option>
							<mat-option value="autoTaggedSingleCriteria">{{ 'CONTRACT_NOTICES.AUTO_TAGGED_SINGLE_CRITERIA' | translate }}</mat-option>
							<mat-option value="autoTaggedMultipleCriteria">{{ 'CONTRACT_NOTICES.AUTO_TAGGED_MULTIPLE_CRITERIA' | translate }}</mat-option>
							<!-- <mat-option value="tagsAll">{{ 'CLIPS.ALL_TAGS' | translate }}</mat-option> -->
						</mat-select>
					</mat-form-field>
					}

					@if (autotagUiEnabled && role === 'admin' && dataAdministrationType === 'CONTRACT_NOTICES') {
					<mat-form-field class="ms-1 reduced-width-field-sm">
						<mat-label>{{ 'CONTRACT_NOTICES.COLOR_FILTER' | translate }}</mat-label>
						<select id="colors" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select id="colors" formControlName="colors" multiple (valueChange)="instantSearch ? filterListItemsDelayed() : null">
							@for (color of autotagColors; track color) {
							<mat-option [value]="color">{{ 'CONTRACT_NOTICES.COLOR_' + color | translate }}</mat-option>
							}
						</mat-select>
					</mat-form-field>

					<mat-checkbox class="ms-1" formControlName="reviewed" (change)="instantSearch ? filterListItemsDelayed() : null">
						{{ 'CONTRACT_NOTICES.REVIEWED_FILTER' | translate }}
					</mat-checkbox>

					<mat-form-field class="ms-1 reduced-width-field-sm">
						<mat-label>{{ 'CONTRACT_NOTICES.SORT_BY' | translate }}</mat-label>
						<mat-select formControlName="sortBy" (valueChange)="instantSearch ? filterListItemsDelayed() : null">
							<mat-option value="createdAt">{{ 'CONTRACT_NOTICES.SORT_BY_CREATED_AT' | translate }}</mat-option>
							<mat-option value="risk">{{ 'CONTRACT_NOTICES.SORT_BY_RISK' | translate }}</mat-option>
						</mat-select>
					</mat-form-field>
					}

					<div class="ms-1 d-flex justify-content-end mb-1">
						<button
							type="button"
							mat-raised-button
							color="primary"
							class="me-1"
							aria-label="Reset form button"
							matTooltip="{{ 'CLIPS.RESET_FORM' | translate }}"
							matTooltipPosition="below"
							(click)="resetForm(filtersFormDirective)">
							<mat-icon class="m-0">restart_alt</mat-icon>
						</button>

						@if (!instantSearch) {
						<button type="submit" mat-raised-button class="me-1" aria-label="Filter button" [disabled]="apiLoading">
							@if(apiLoading) {
							<mat-spinner diameter="20"></mat-spinner>
							} @else {
							<span>{{ 'BUTTON.SHOW' | translate }}</span>
							}
						</button>
						}
					</div>
				</form>
			</div>
			<mat-divider class="w-100"></mat-divider>
		</mat-card-content>
	</mat-card>
</div>
